import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/ImprintPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ImprintPage: React.FC = () => {
  return (
    <div className="imprint-page">
      <Helmet>
        <title>Impresszum | Pelyák Adél</title>
        <meta name="description" content="Pelyák Adél pedikűr és manikűr szolgáltatások impresszuma. Céginformációk, elérhetőségek és jogi információk." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Header />
      <main className="imprint-content">
        <div className="imprint-container">
          <h1 className="imprint-title">Impresszum</h1>
          
          <section className="imprint-section">
            <h2>Céginformációk</h2>            
            <p>Cégnév: SoulAir Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság</p>
            <p>Székhely: 1164 Budapest, Vidámvásár utca 16.</p>            
          </section>
          <section className="imprint-section">
            <h2>Elérhetőség</h2>
            <p>Telefonszám: +36 30 248 5090</p>
            <p>Email: info@nailsroom.hu</p>
          </section>

          <section className="imprint-section">
            <h2>Jogi információk</h2>
            <p>Adószám: 25067682-1-42</p>
            <p>Cégjegyzékszám: 01 09 197848</p>
            <p>Céget bejegyző hatóság: Fővárosi Törvényszék Cégbírósága</p>
            <p>Kamara: Magyar Kereskedelmi és Iparkamara</p>
            <p>Tárhely szolgáltató: DATATRONIC Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság</p>
          </section>

          <section className="imprint-section">
            <h2>Jogi nyilatkozat</h2>
            <p>A gondos tartalomellenőrzés ellenére nem vállalunk felelősséget a külső hivatkozások tartalmáért. A hivatkozott oldalak üzemeltetői kizárólagos felelősséget vállalnak azok tartalmáért.</p>
            </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ImprintPage; 